/** Latest selectable date for last organic application (today). */
export const LAST_ORGANIC_MAX_DATE = new Date();
